exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.circle[data-v-ce0a48a2] {\n  border-radius: 50%;\n  height: 40px;\n  text-align: center;\n  width: 40px;\n}\n.initials[data-v-ce0a48a2] {\n  font-weight: normal;\n  font-size: calc(40px / 2);\n  line-height: 1;\n  position: relative;\n  top: calc(40px / 4);\n  color: #FFFFFF;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ce0a48a2","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"indentedSyntax":true,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/LetterAvatar.vue
// module id = OSvb
// module chunks = 15